import React from "react";

import EmailForm from "./EmailForm";

export default function FormDisplay({
  formikProps,
  editState,
  scheduledTime,
  setScheduledTime,
  groupList,
  templates,
}) {
  return (
    <React.Fragment>
      <EmailForm
        formikProps={formikProps}
        editState={editState}
        scheduledTime={scheduledTime}
        setScheduledTime={setScheduledTime}
        groupList={groupList}
        templates={templates}
      />
    </React.Fragment>
  );
}
